

// Class Definition

var pixKeyMaskVar = null;
var qrCodeComponent = function() {
    

  
    
    var typePixMask = function(){
    
        var pixKey = document.querySelector("#pixKey");
        
        
        function doMask(id) {

            if(pixKeyMaskVar!=null){
                pixKeyMaskVar.destroy();
            }

            switch (id) {
                case '1':
                    
                    pixKeyMaskVar = IMask(pixKey, {
                        mask: [
                            {
                            mask:'(00) 0000-0000',
                            },
                            {
                            mask:'(00) 00000-0000',
                            },
                        ],
                    });
                break;
                case '2':
                    
                break;
                case '3':
                    pixKeyMaskVar = IMask(pixKey, {
                        mask: [
                            {
                                mask: '000.000.000-00',
                                maxLength: 11
                            },
                        ],
                    });
                break;
                case '4':
                    pixKeyMaskVar = IMask(pixKey, {
                        mask: [
                            {
                                mask: '00.000.000/0000-00',
                                maxLength: 11
                            },
                        ],
                    });
                break;
                case '5':
                   
                break;
            
                default:
                break;
            }
        }

        $('input[name=typePix]').on('click',function(){
            doMask($('input[name=typePix]:checked').val());
        });
        doMask($('input[name=typePix]:checked').val());


        
    };

    var qrCodeDots = function(){
    
        function selectQrCode() {
            $('.qrcodemode').removeClass('active');
            $('.qrcodemode[data-dot-id="' + $('input[name="dots"]:checked').val() + '"').addClass('active');
        }
        $('input[name="dots"]').on('click',function(){
            selectQrCode();
        });
        selectQrCode();
    };
    
    
    var qrCodeFormat = function(){
        function qrCodeLogo(status) {
            if(status){
                $('.logo').show();
            }else{
                $('.logo').hide();
            }
        }
        $('select[name="format"]').on('change', function() {
            qrCodeLogo( ($('select[name="format"]').val()==='svg' ? false : true) ); 
        });
        qrCodeLogo( ($('select[name="format"]').val()==='svg' ? false : true) );
    
    };

    var qrCodeColors = function(){
                
        let colorsInfo = [
            {
                id:'qrCodeColorHex',
                path:'svg > g > g > path'
            },
            {
                id:'qrCodeBGHex',
                path:'svg > rect'
            },
            {
                id:'block1Hex',
                path:'svg > g > g > g:nth-child(1) > g path'
            },
            {
                id:'block2Hex',
                path:'svg > g > g > g:nth-child(2) > g path'
            },
            {
                id:'block3Hex',
                path:'svg > g > g > g:nth-child(3) > g path'
            }
        ];

        for(let i=0; i<=colorsInfo.length -1; i++){
            
            document.getElementById(colorsInfo[i].id).addEventListener("input", function(event){
                console.log(event.target.value);

                $(colorsInfo[i].path).attr('fill',this.value);

            }, false);
        }

    };

    var downloadSVG = function(){


        $('.downloadSVG').on('click', function(){

            var source = $('.qrcode-result').html();
            if(!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)){
                source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
            }
            
            if(!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)){
                source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
            }

            source = source.replace('width="250" height="250"', '');

            //add xml declaration
            source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

            //convert svg source to URI data scheme.
            var url = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(source);


            var dl = document.createElement("a");
            dl.setAttribute("href", url);
            dl.setAttribute("download", "qrcode.svg");
            dl.click();
        });

    };

    var downloadPNG = function(){

        
        $('.downloadPNG').on('click', function(){

            window.saveSvgAsPng.saveSvgAsPng($('.qrcode-result svg')[0], "qrcode.png", {scale: 3});
            
        });

    };
    

    return {
        init: function() {
            qrCodeFormat();
            qrCodeDots();
            qrCodeColors();
            downloadSVG();
            downloadPNG();
            typePixMask();
        }
    };
}();

// Class Initialization
$(function(){
    qrCodeComponent.init();
});